export default __webpack_public_path__ + "static/media/default-qr.62b04f63.png";